import {
  booleanAttribute,
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  model,
} from '@angular/core';
import { BspkButton } from '../button';
import { BspkTxt } from '../txt';
import { BspkDialog, DialogPlacement } from '../dialog';

@Component({
  selector: 'bspk-modal',
  templateUrl: './modal.component.html',
  styleUrl: './modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BspkTxt, BspkButton, BspkDialog],
})
export class BspkModal {
  readonly open = model<boolean>(false);
  readonly header = input.required<string>();
  readonly cancelButton = input<string | boolean>(false);
  readonly callToAction = input<{ label: string; onClick: VoidFunction }>();
  readonly placement = input<DialogPlacement>('center');
  readonly widthFull = input(false, { transform: booleanAttribute });
  readonly width = input<string>('600px');

  readonly buttons = computed(() => {
    const nextButtons: any[] = [];

    if (this.callToAction()) {
      nextButtons.push({
        ...this.callToAction(),
        variant: 'primary',
      });

      if (this.cancelButton()) {
        nextButtons.push({
          label: typeof this.cancelButton() === 'string' ? this.cancelButton() : 'Cancel',
          onClick: () => this.open.set(false),
          variant: 'tertiary',
        });
      }
    }

    return nextButtons;
  });
}
